module.exports = __webpack_public_path__ + "img/1-5.1a619d01.svg";